<template>
    <div style="margin:10px">
        <Row style="margin-bottom: 20px">
            <Button style="float:right" shape="circle" icon="md-refresh" @click="onClickRefresh"></Button>
        </Row>

        <Row style="margin-bottom: 20px">

            <Form :model="formItem" :label-width="150">
                <FormItem label="Gnosis Safe Address">
                    <Input v-model="formItem.gnosisSafeAddr" placeholder="0x..." style="width:380px">
                    </Input>
                </FormItem>
                <FormItem label="Safe Module Address">
                    <Input v-model="formItem.safeModuleAddr" placeholder="0x..." style="width:380px">
                    </Input>
                </FormItem>
                <FormItem label="Network">
                    <Select v-model="formItem.selectNetId" style="width:150px;margin-left: 10px">
                        <Option v-for="item in chainInfoList" :value="item.id" :key="item.id">{{ item.chainName }}
                        </Option>
                    </Select>
                </FormItem>

                <FormItem label="Wrapped Token">
                    <Select v-model="formItem.wrapTokenAddress" style="width:150px;margin-left: 10px">
                      <Option v-for="item in wrappedTokenList" :value="item.address" :key="item.address">{{ item.name }}
                      </Option>
                    </Select>
                    <Button type="success" style="margin-left: 10px" @click="onCheckTokenBalance()">
                        Check
                    </Button>
                </FormItem>
                <FormItem label="Amount">
                    <Input v-model="formItem.unwrapValue" placeholder="输入Unwrap数量" style="width:380px">
                    </Input>
                    <Tag type="border" color="primary" style="margin-left: 10px" v-if="this.formItem.wrapTokenInfo">
                        {{this.formItem.wrapTokenInfo.symbol}}
                    </Tag>
                </FormItem>

                <FormItem>
                    <Button type="error" @click="onClickUnwrap()">
                        Unwrap
                    </Button>
                </FormItem>
            </Form>

        </Row>

    </div>
</template>

<script>
import TagList from '@/components/common/TagList'
import contract from '@/utils/contracts/common'
import { waitForTx, chainInfoMap, wrappedTokenList } from '@/utils/tx'
import tools from '@/utils/contracts/tools'

export default {
  name: 'token_unwrap',
  components: {
    TagList,
  },

  data () {
    let chainInfoList = []
    for (let id in chainInfoMap) {
      let info = chainInfoMap[id]
      info.id = id
      chainInfoList.push(info)
    }

    return {
      indexAddr: '',
      formItem: {
        gnosisSafeAddr: '',
        safeModuleAddr: '',
        wrapTokenAddress: "",
        withdrawValue: 0
      },
      chainInfoList: chainInfoList,
      wrappedTokenList: wrappedTokenList,
      netId: 1,
      myAddr: '',
      tokenList: [],
    }
  },
  async mounted () {
    this.netId = await web3.eth.net.getId()
    this.formItem = {
      gnosisSafeAddr: this.$route.query.gnosisSafeAddr,
      safeModuleAddr: this.$route.query.safeModuleAddr,
      wrapTokenAddress: this.$route.query.wrapTokenAddress,
      unwrapValue: 0
    }
    this.myAddr = window.currAddress
    this.$set(this.formItem, 'selectNetId', '' + this.netId)
    this.$set(this.formItem, 'wrapTokenAddress', '' + wrappedTokenList[0].address)
    await this.onCheckTokenBalance()
  },

  methods: {
    divDecimals: tools.divDecimals,
    mulDecimals: tools.mulDecimals,
    async onClickRefresh () {
      window.location.reload()
    },
    async onCheckTokenBalance () {
      if (!this.formItem.wrapTokenAddress || !this.formItem.gnosisSafeAddr) return
      this.formItem.wrapTokenInfo = await contract.getERC20Info(this.formItem.wrapTokenAddress)
      this.formItem.wrapTokenBalance = await contract.getERC20BalanceOf(this.formItem.wrapTokenAddress, this.formItem.gnosisSafeAddr)
      this.formItem.unwrapValue = this.divDecimals(this.formItem.wrapTokenBalance, this.formItem.wrapTokenInfo.decimals).toString()
    },
    onClickUnwrap () {
      if (!this.formItem.wrapTokenAddress || !this.formItem.unwrapValue) return
      let safe = contract.getSafe(this.formItem.safeModuleAddr)
      let value = this.mulDecimals(this.formItem.unwrapValue, this.formItem.wrapTokenInfo.decimals)
      let data = web3.eth.abi.encodeFunctionCall({
        name: 'withdraw',
        type: 'function',
        inputs: [{
            type: 'uint256',
            name: 'amount'
        }]
      }, [value.toString()]);
      safe.methods
        .execTransaction(this.formItem.wrapTokenAddress, data.toString())
        .send({ from: window.currAddress }, (error, transactionHash) => {
          waitForTx(this, error, transactionHash, (receipt) => {
            if (!error) {
              this.onClickRefresh()
            }
          })
        })
    },
  }
}
</script>

<style scoped>

</style>
